import  { useState } from 'react';
import Search from '../../pics/search.png'
import LoginImage from '../../pics/icons/login.png'
import questionMark from '../../pics/icons/questionMark.png'
import Patreon from '../../pics/patreon_logo.png'
import Discord from '../../pics/icons/discord.png'
import SignIn from '../SignIn';


function SideMenu({showSearchList, setShowSearchList, socket}) {
    const [isOpen, setIsOpen] = useState(false);

    // Toggle the menu state
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`side-menu ${isOpen ? 'open' : ''}`}>
            <button className="toggle-button" onClick={toggleMenu}>
               {isOpen ? 
                    <svg width="20" height="20" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="28,28 56,48 56,8" fill="#FFFFFF"/>
                        <polygon points="8,26 32,48 32,8" fill="#FFFFFF"/>
                    </svg> 
                : 
                    <svg width="20" height="20" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="32,28 8,50 8,8" fill="#FFFFFF"/>
                        <polygon points="56,28 32,50 32,8" fill="#FFFFFF"/>
                    </svg>
                }
            </button>
            <div className='menu'>
                <div className='menuItem' onClick={() => setShowSearchList(!showSearchList)}>
                    <img className='menuIcon' alt='monsterSearch' src={Search}/> {showSearchList ? 'Hide' : 'Show'} Search
                </div>
                
                <hr/>
                <div className='menuItem'>
                    <div className='loginImageFlex'>
                        <img src={LoginImage} alt="Login" className="menuIcon" onClick={() => setIsOpen(!isOpen)} />
                        <SignIn socket={socket}/>
                    </div>
                </div>    
                
                <div className='menuItemLow'>
                    <div>
                        <a className='menuHelpLink' href='https://discord.gg/26TWEMqdka' target="_blank" rel="noreferrer"> 
                            <img src={Discord} alt="Discord" className="menuIcon" /> Discord
                        </a>
                    </div>
                    <div>
                        <a className='menuHelpLink' href='https://patreon.com/DmBuddy' target="_blank" rel="noreferrer"> 
                            <img src={Patreon} alt="Patreon" className="menuIcon" /> Patreon
                        </a>
                    </div>
                    <div>
                        <a className='menuHelpLink' href='/help'> 
                            <img src={questionMark} alt="Help" className="menuIcon" /> Help  Page
                        </a>
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default SideMenu;
